import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

export type ConnectivityEmailListParams = Parameters<typeof VendorsService.listConnectivityEmailProcessing>[0];
export type ConnectivityEmailExportParams = Parameters<typeof VendorsService.exportConnectivityEmailProcessing>[0];

export const connectivityEmailProcessingQueryKeys = {
  all: ['connectivity', 'emailProcessing'] as const,
  list: (filters?: ConnectivityEmailListParams) =>
    [...connectivityEmailProcessingQueryKeys.all, 'list', filters ?? {}] as const,
  body: (recordId?: string | null) => [...connectivityEmailProcessingQueryKeys.all, 'body', recordId] as const,
};

export function useGetConnectivityEmailProcessing(filters?: ConnectivityEmailListParams) {
  return useQuery({
    queryKey: connectivityEmailProcessingQueryKeys.list(filters),
    queryFn: ({ signal }) => VendorsService.listConnectivityEmailProcessing(filters, { signal }),
    placeholderData: keepPreviousData,
  });
}

export function useGetConnectivityEmailProcessingBody(recordId?: string | null) {
  return useQuery({
    queryKey: connectivityEmailProcessingQueryKeys.body(recordId),
    queryFn: ({ signal }) => VendorsService.getConnectivityEmailProcessingBody(recordId as string, { signal }),
    enabled: !!recordId,
    staleTime: Infinity,
  });
}

export function useExportConnectivityEmailProcessing() {
  return useMutation({
    mutationFn: (filters: ConnectivityEmailExportParams) => VendorsService.exportConnectivityEmailProcessing(filters),
  });
}
